// extracted by mini-css-extract-plugin
export default {"buttonPrimary":"markets__buttonPrimary__OidtBS","disabled":"markets__disabled__eqIrx0","loading":"markets__loading__cq2afB"};